module.exports = __webpack_public_path__ + "img/icon-weight.e222e6d7.png";